var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from '@empiriecom/module-components/utils/styled-components';
// eslint-disable-next-line import/no-cycle
import { FontNames } from '../../../interfaces/cmsdata';
var FontStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), Object.entries(FontNames).reduce(function (accumulator, _a) {
    var font = _a[0];
    if (font === 'default') {
        return '';
    }
    return (font &&
        accumulator + "\n      ." + font + " {\n        font-family: " + font + ";\n      }");
}, ''));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n\n  ", "\n\n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ul,\n    ol {\n    margin: 0 0 0 1rem;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  blockquote,\n  cite,\n  code,\n  pre,\n  dl,\n  dt,\n  dd,\n  li,\n  p {\n    margin: 0;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  blockquote,\n  cite,\n  code,\n  pre,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  p {\n    word-break: break-word;\n    padding: 0 0 0.5rem 0;\n    &:last-of-type {\n      padding-bottom: 0;\n    }\n  }\n"], ["\n  display: inline-block;\n  width: 100%;\n\n  ", "\n\n  ",
    "\n  \n  ",
    "\n  \n  ",
    "\n  \n  ",
    "\n  \n  ",
    "\n  \n  ul,\n    ol {\n    margin: 0 0 0 1rem;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  blockquote,\n  cite,\n  code,\n  pre,\n  dl,\n  dt,\n  dd,\n  li,\n  p {\n    margin: 0;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  blockquote,\n  cite,\n  code,\n  pre,\n  dl,\n  dt,\n  dd,\n  ol,\n  ul,\n  li,\n  p {\n    word-break: break-word;\n    padding: 0 0 0.5rem 0;\n    &:last-of-type {\n      padding-bottom: 0;\n    }\n  }\n"])), FontStyles, function (_a) {
    var styleMargin = _a.styleMargin;
    return styleMargin !== '' ? "margin: " + styleMargin + ";" : '';
}, function (_a) {
    var stylePadding = _a.stylePadding;
    return stylePadding !== '' ? "padding: " + stylePadding + ";" : '';
}, function (_a) {
    var styleBackgroundColor = _a.styleBackgroundColor;
    return styleBackgroundColor !== '' ? "background-color: " + styleBackgroundColor + ";" : '';
}, function (_a) {
    var styleTextAlign = _a.styleTextAlign;
    return styleTextAlign !== undefined ? "text-align: " + styleTextAlign + ";" : '';
}, function (_a) {
    var styleActiveBorder = _a.styleActiveBorder, component = _a.theme.component;
    return styleActiveBorder
        ? "border: 1px solid " + component.html.default.wrapper.borderColorEmphasis + ";"
        : null;
});
export default Wrapper;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map